const LOGO_SRC =
  "https://customer-assets.emergentagent.com/job_campground-command/artifacts/hmfcl65x_KAOGMA%202026%20PROFILE%20PICTURE%20HIRES.png";

export const Logo = ({ size = "md", showText = true }) => {
  const dim =
    size === "sm" ? "h-10 w-10" : size === "lg" ? "h-20 w-20" : size === "xl" ? "h-28 w-28" : "h-12 w-12";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src={LOGO_SRC}
        alt="KAOGMA Festival 2026"
        className={`${dim} object-contain rounded-full kf-border bg-white shadow-[3px_3px_0_#3D1E6D]`}
      />
      {showText && size !== "xl" && (
        <div className="leading-none hidden sm:block">
          <div className="display text-xl tracking-tight text-[#3D1E6D]">KAOGMA</div>
          <div className="text-[10px] font-bold tracking-[0.3em] text-[#6B4E9E] uppercase">
            Festival ’26
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
